/**
 * Phase 101fk.4 (Feb 2026) — Enregistrement du Service Worker AM.
 *
 * Enregistre `/service-worker.js` en production (pas en dev pour éviter les
 * caches capricieux pendant les modifs).
 *
 * Notifie l'app via `window.dispatchEvent(new CustomEvent("sw-update"))` quand
 * une nouvelle version est disponible → composant `PWAUpdateBanner` propose
 * un "Recharger pour mettre à jour".
 */

const SW_URL = "/service-worker.js";

export function registerServiceWorker() {
  if (typeof window === "undefined") return;
  if (!("serviceWorker" in navigator)) return;

  // En dev (localhost), on n'enregistre pas — hot reload cassé sinon
  const host = window.location.hostname;
  const isLocalhost = host === "localhost" || host === "127.0.0.1" || host === "[::1]";
  if (isLocalhost && process.env.NODE_ENV !== "production") {
    return;
  }

  window.addEventListener("load", async () => {
    try {
      const reg = await navigator.serviceWorker.register(SW_URL);

      // Détecte les mises à jour en attente
      if (reg.waiting) {
        window.dispatchEvent(new CustomEvent("sw-update", { detail: { registration: reg } }));
      }

      reg.addEventListener("updatefound", () => {
        const installing = reg.installing;
        if (!installing) return;
        installing.addEventListener("statechange", () => {
          if (installing.state === "installed" && navigator.serviceWorker.controller) {
            window.dispatchEvent(new CustomEvent("sw-update", { detail: { registration: reg } }));
          }
        });
      });

      // Force reload quand le SW actif change (skipWaiting → new controller)
      let refreshing = false;
      navigator.serviceWorker.addEventListener("controllerchange", () => {
        if (refreshing) return;
        refreshing = true;
        window.location.reload();
      });
    } catch (err) {
      // Silencieux : SW non enregistré n'empêche pas l'app de tourner
      console.info("[SW] register failed:", err && err.message);
    }
  });
}

export function skipWaitingAndReload(registration) {
  if (registration && registration.waiting) {
    registration.waiting.postMessage({ type: "SKIP_WAITING" });
  } else if (typeof window !== "undefined") {
    window.location.reload();
  }
}
